<template>
  <div id="content">

    <!--    LOADING-->
    <div
        v-if="authLoading"
        class="
          tw-h-[calc(100vh-50px)] tw-mt-skip-header tw-flex tw-justify-center tw-items-center

          desktop:tw-mt-skip-header-d desktop:!tw-h-[calc(100vh-63px)]"
    >
      <ui-mini-loader>
      </ui-mini-loader>
    </div>

    <!--    LOADED-->
    <div
        v-if="!authLoading && availableAuthMethods"
        class="pobr-auth"
    >
      <ui-header
          v-if="!hideHeader"
          :show-back-button="false"
          @back="onStepChange('BACK')"
      >
      </ui-header>

      <ui-form
          :showStepper=false
          :current="currentStep"
          id="content"
          class="tw-h-full tw-bg-tzz-green-light"

          @progress-next="onStepChange(currentStep + 1)"
      >

        <!--        STEP 0-->
        <ui-formgroup
            v-if="currentStep === 0"
            :key="0"
            class="
              tw-absolute tw-w-full

              landscape:tw-flex landscape:tw-h-full landscape:tw-justify-start"
        >
          <!--      I.TRIGLAV LOGIN -->
          <div
              v-if="availableAuthMethods.includes(2) && !authData.iTriglav"
              class="
                pobr_auth__itriglav
                tw-relative
                tw-flex tw-flex-col tw-justify-center tw-items-center
                tw-mb-0 tw-py-[3rem]
                tw-bg-center tw-bg-no-repeat tw-bg-cover

                landscape:tw-w-1/2 landscape:tw-h-[calc(100%-50px)]

                desktop:!tw-h-[calc(100%-63px)]"
              :class="{'tw-my-skip-header': !hideHeader, 'desktop:tw-mt-skip-header-d': !hideHeader, 'landscape:!tw-h-[100%]': hideHeader}"
          >

            <div
                class="
                  pobr_auth__itriglav-shadow
                  tw-absolute
                  tw-w-full tw-h-full"
            >
            </div>

            <h1
                class="
                  pobr_auth__itriglav-title
                  tw-z-10 tw-mb-mid
                  tw-text-white tw-text-title tw-text-center tw-font-bold tw-tracking-title

                  mini:tw-w-11/12
                  mob:tw-w-8/12 mob:tw-max-w-[343px]
                  tablet:tw-max-w-[500px]

                  landscape:tw-w-11/12
                  landscape:tw-text-40 landscape:tw-leading-[56px] landscape:tw-font-[600] landscape:tw-tracking-[2.5px]"
            >
              Za imetnike i.triglav računa
            </h1>

            <ui-button
                class="
                  pobr_auth__itriglav-login
                  tw-z-10 !tw-m-0

                  mini:tw-w-11/12
                  mob:tw-w-8/12 mob:tw-max-w-[343px]
                  tablet:tw-max-w-[400px]"
                label="PRIJAVA"
                :type="'red'"
                @click="onOpenITriglav"
            ></ui-button>
          </div>

          <!--      I.TRIGLAV LOGGED IN-->
          <div
              v-if="availableAuthMethods.includes(2) && authData.iTriglav"
              class="
                pobr_auth__itriglav-logged_in
                tw-relative
                tw-flex tw-flex-col tw-justify-center tw-items-center
                tw-my-skip-header

                landscape:tw-w-1/2 landscape:!tw-h-[calc(100%-50px)]
                desktop:tw-mt-skip-header-d desktop:!tw-h-[calc(100%-63px)]"
          >

            <h1
                class="
                  pobr_auth__itriglav-title
                  tw-z-10 tw-mb-mid
                  tw-text-white tw-text-title tw-text-center tw-font-bold tw-tracking-title

                  mini:tw-w-11/12
                  mob:tw-w-8/12 mob:tw-max-w-[343px]
                  tablet:tw-max-w-[500px]

                  landscape:tw-w-11/12
                  landscape:tw-text-40 landscape:tw-leading-[56px] landscape:tw-font-[600] landscape:tw-tracking-[2.5px]"
            >
              Pozdravljeni, <br> {{ authData.autofill.displayName }}!
            </h1>

            <p
                class="
                  pobr_auth__itriglav-logout
                  tw-text-white tw-mx-auto tw-text-center

                  mini:tw-w-11/12
                  mob:tw-w-8/12 mob:tw-max-w-[343px]
                  tablet:tw-max-w-[500px]"
            >
              Če ne sklepate za sebe,

              <button
                  class="tw-text-white tw-underline tw-underline-offset-3"
                  @click="onITriglavLogout"
              >
                se odjavite.
              </button>
            </p>
          </div>

          <!--      ALTERNATIVES-->
          <div
              v-if="authData && !authData.iTriglav"
              class="
              pobr_auth__alt
              tw-pt-big

              landscape:tw-w-1/2 landscape:tw-h-[calc(100%-50px)]
              landscape:tw-flex landscape:tw-flex-col landscape:tw-justify-center

              desktop:!tw-h-[calc(100%-63px)] desktop:tw-pt-[63px] desktop:tw-mt-small+"
          >
            <h1
                class="
                  pobr_auth__alt-title
                  tw-mt-0 tw-mb-small tw-mx-auto
                  tw-text-center tw-text-title tw-font-bold tw-tracking-title tw-text-tzz-dark-gray tw-leading-40

                  mini:tw-w-11/12
                  mob:tw-w-8/12 mob:tw-max-w-[343px]
                  tablet:tw-max-w-[500px]

                  landscape:tw-w-11/12
                  landscape:tw-text-40 landscape:tw-leading-[56px] landscape:tw-font-[600] landscape:tw-tracking-[2.5px]"
            >
              Nimate <br/> i.triglav računa?
            </h1>

            <h3
                class="
                  pobr_auth__alt-subtitle
                  tw-mb-mid tw-mx-auto
                  tw-text-center tw-text-tzz-dark-gray tw-text-normal tw-leading-30 tw-tracking-wide

                  mini:tw-w-11/12
                  mob:tw-w-8/12 mob:tw-max-w-[343px]
                  tablet:tw-max-w-[500px]"
            >
              <span class="tw-font-semibold">Ni problema.</span> Nadaljujte z drugimi načini prijave.
            </h3>

            <ui-button
                class="
                  pobr_auth__alt-see
                  !tw-flex !tw-my-0 !tw-mx-auto !tw-text-normal

                  mini:tw-w-11/12
                  mob:tw-w-8/12 mob:tw-max-w-[343px]
                  tablet:tw-max-w-[400px]"
                label="NADALJUJ"
                :type="'primary'"
                fg-progress-next
                fg-keydown-enter-click
            ></ui-button>
          </div>


          <!--      ITRIGLAV ENTER-->
          <div
              v-if="authData && authData.iTriglav"
              class="
              pobr_auth__alt
              tw-pt-small

              landscape:tw-w-1/2 landscape:!tw-h-[calc(100%-50px)]
              landscape:tw-mt-[50px]
              landscape:tw-flex landscape:tw-flex-col landscape:tw-justify-center

              desktop:tw-mt-[63px]
              desktop:!tw-h-[calc(100%-63px)]"
          >

            <h3
                class="
                  pobr_auth__alt-subtitle
                  tw-mb-mid tw-mx-auto
                  tw-text-center tw-text-tzz-dark-gray tw-text-normal tw-leading-30 tw-tracking-wide

                  mini:tw-w-11/12
                  mob:tw-w-8/12 mob:tw-max-w-[343px]
                  tablet:tw-max-w-[500px]"
            >
              Za dostop do obrazca kliknite na gumb.
            </h3>

            <ui-button
                class="
                  pobr_auth__alt-see
                  !tw-flex !tw-my-0 !tw-mx-auto !tw-text-normal

                  mini:tw-w-11/12
                  mob:tw-w-8/12 mob:tw-max-w-[343px]
                  tablet:tw-max-w-[400px]"
                label="NADALJUJ"
                :type="'primary'"
                @click="onEnter()"
                fg-keydown-enter-click
            ></ui-button>
          </div>
        </ui-formgroup>

        <!--    STEP 1 - ALTERNATIVE AUTH METHODS -->
        <ui-formgroup
            v-else-if="currentStep === 1"
            :key="1"
            class="
            tw-absolute tw-w-full"
        >
          <div
              class="
                pobr_auth__alts
                tw-mt-skip-header tw-mx-auto

                mini:tw-w-11/12
                mob:tw-w-[343px]

                desktop:tw-mt-skip-header-d"
          >
            <h1
                class="
                  pobr_auth__alts-title
                  tw-mt-0 tw-mb-mid tw-pt-mid tw-mx-auto
                  tw-text-center tw-text-title tw-font-bold tw-tracking-title tw-text-tzz-dark-gray tw-leading-40

                  mob:tw-max-w-[343px]
                  desktop:tw-pt-extra"
            >
              Za nadaljevanje izberite način prijave
            </h1>

            <ui-button-with-icon
                v-for="am of alternativeAuthMethods"
                :key="am"
                :label="labelsByAuthMethod[am]"
                :show-next-icon="true"

                @click="selectAlternativeAuthMethod(am)"
            >
            </ui-button-with-icon>

            <div
                v-if="availableAuthMethods.includes(9)"
            >

              <button
                  class="
                    back-to-alt
                    tw-w-full tw-mt-0 tw-mb-40
                    tw-text-center tw-text-tzz-blue tw-font-bold tw-text-normal"
                  @click="selectAlternativeAuthMethod(9)"
              >
                Nadaljuj brez prijave
              </button>
            </div>

            <ui-button
                class="
                  !tw-flex !tw-my-0 !tw-mx-auto !tw-text-normal tw-w-full"
                label="NAZAJ"
                :type="'primary'"
                @click="onStepChange('BACK')"
            ></ui-button>

          </div>
        </ui-formgroup>

        <!--    ALTERNATIVE AUTH - DAVCNA & DATUM ROJSTVA -->
        <ui-formgroup
            v-else-if="currentStep === 4"
            :key="4"
            class="
            tw-absolute tw-w-full tw-h-full"

            @validated="allowVATbirthDateEnter = $event"
        >
          <div
              class="
                pobr_auth__alts
                tw-mt-skip-header tw-w-full tw-mx-auto

                mini:tw-w-11/12
                mob:tw-w-[343px]

                desktop:tw-mt-skip-header-d"
          >
            <h1
                class="
                  pobr_auth__alts-title
                  tw-mt-0 tw-mb-extra tw-pt-mid
                  tw-text-center tw-text-title tw-font-bold tw-tracking-title tw-text-tzz-dark-gray tw-leading-40

                  desktop:tw-pt-extra"
            >
              Vpišite vašo davčno številko in datum rojstva
            </h1>

            <ui-input
                label="Davčna številka"
                name="vat"
                v-model="vatNumberInput"
                :required="true"
                :validate="davcnaValidate"
                :show-valid-indicator="true"

                class="!tw-m-0 !tw-mx-auto !tw-mb-small"
            ></ui-input>

            <ui-datepicker
                label="Datum rojstva"
                name="birthDate"
                :value="birthDateInput"
                @change="birthDateInput = $event"
                :openDate="birthDateOpen"
                :required="true"
                class="!tw-mt-0 !tw-mb-40 !tw-mx-auto !tw-w-full"
            ></ui-datepicker>

            <button
                class="
              back-to-alt
              tw-w-full tw-mt-0 tw-mb-40
              tw-text-center tw-text-tzz-blue tw-font-bold tw-text-normal"
                @click="onStepChange('BACK')"
            >
              Drugi načini prijave
            </button>

            <ui-button
                class="
                  pobr_auth__alt-see
                  !tw-flex !tw-my-0 !tw-mx-auto !tw-mb-20 !tw-text-normal tw-w-full"
                label="NADALJUJ"
                :type="'primary'"

                :disabled="!allowVATbirthDateEnter"
                @click="onEnter()"
                fg-keydown-enter-click
            ></ui-button>

            <ui-button
                class="
                  !tw-flex !tw-my-0 !tw-mx-auto !tw-text-normal tw-w-full"
                label="NAZAJ"
                :type="'flat green'"
                @click="onStepChange('BACK')"
            ></ui-button>

          </div>
        </ui-formgroup>

        <!--    ALTERNATIVE AUTH - DAVCNA & KZZ -->
        <ui-formgroup
            v-else-if="currentStep === 3"
            :key="3"
            class="
            tw-absolute tw-w-full tw-h-full"

            @validated="allowVATKZZEnter = $event"
        >
          <div
              class="
                pobr_auth__alts
                tw-mt-skip-header tw-mx-auto

                mini:tw-w-11/12
                mob:tw-w-[343px]

                desktop:tw-mt-skip-header-d"
          >
            <h1
                class="
                  pobr_auth__alts-title
                  tw-mt-0 tw-mb-extra tw-pt-mid
                  tw-text-center tw-text-title tw-font-bold tw-tracking-title tw-text-tzz-dark-gray tw-leading-40

                  desktop:tw-pt-extra"
            >
              Vpišite vašo davčno in ZZZS številko
            </h1>

            <ui-input
                label="Davčna številka"
                name="vat"
                v-model="vatNumberInput"
                :required="true"
                :validate="davcnaValidate"
                :show-valid-indicator="true"

                class="!tw-m-0 !tw-mx-auto !tw-mb-small"
            ></ui-input>

            <div
                class="
                tw-flex tw-justify-between tw-flex-wrap
                !tw-m-0 !tw-mx-auto !tw-mb-small

                mini:tw-w-full
                mob:tw-w-[343px]"
            >
              <ui-input
                  label="ZZZS številka"
                  name="kzz"
                  :maxlength="9"
                  :minlength="9"
                  v-model="kzzInput"
                  :validate="kzzValidate"
                  :required="true"

                  class="!tw-w-[calc(100%-34px)] !tw-m-0"
              ></ui-input>

              <stevilka-zdravstvene-kartice-info></stevilka-zdravstvene-kartice-info>
            </div>

            <button
                class="
              back-to-alt
              tw-w-full tw-mt-0 tw-mb-40
              tw-text-center tw-text-tzz-blue tw-font-bold tw-text-normal"
                @click="onStepChange('BACK')"
            >
              Drugi načini prijave
            </button>

            <ui-button
                class="
                pobr_auth__alt-see
                !tw-flex !tw-my-0 !tw-mx-auto !tw-mb-20 !tw-text-normal tw-w-full"
                label="NADALJUJ"
                :type="'primary'"

                :disabled="!allowVATKZZEnter"
                @click="onEnter()"
                fg-keydown-enter-click
            ></ui-button>

            <ui-button
                class="
                  !tw-flex !tw-my-0 !tw-mx-auto !tw-text-normal tw-w-full"
                label="NAZAJ"
                :type="'flat green'"
                @click="onStepChange('BACK')"
            ></ui-button>

          </div>
        </ui-formgroup>

        <!--    ALTERNATIVE AUTH - INDETIFIKACIJA S SMS KODO -->
        <ui-formgroup
            v-else-if="currentStep === 6"
            :key="6"
            class="
            tw-absolute tw-w-full tw-h-full"
        >
          <div
              class="
                pobr_auth__alts
                tw-mt-skip-header tw-mx-auto

                mini:tw-w-11/12
                mob:tw-w-[343px]

                desktop:tw-mt-skip-header-d"
          >
            <h1
                class="
                  pobr_auth__alts-title
                  tw-mt-0 tw-mb-extra tw-pt-mid
                  tw-text-center tw-text-title tw-font-bold tw-tracking-title tw-text-tzz-dark-gray tw-leading-40

                  desktop:tw-pt-extra"
            >
              Identifikacija s SMS kodo
            </h1>

            <p
                class="
                  potrditev-alternativnega-kontakta-text
                  tw-mt-mid tw-mb-xs
                  tw-text-center tw-text-normal tw-leading-22 tw-text-tzz-dark-gray"
            >
              <span>Na telefonsko številko:</span>
            </p>

            <p
                class="
                  potrditev-alternativnega-kontakta-text
                  tw-mb-xs
                  tw-text-center tw-text-normal tw-leading-22 tw-font-bold tw-text-tzz-dark-gray"
            >
              {{ authContactPreAuth }}
            </p>
            <p
                class="
                  potrditev-alternativnega-kontakta-text
                  tw-mb-mid
                  tw-text-center tw-text-normal tw-leading-22 tw-text-tzz-dark-gray"
            >
              vam bomo poslali validacijsko kodo za dostop. Ko kodo prejmete, jo vnesite v avtentikacijsko polje na
              naslednjem koraku.
              <br>
              Po uspešni potrditvi kode lahko dostopate do vašega obrazca.
            </p>

            <ui-button
                class="
                pobr_auth__alt-see
                !tw-flex !tw-my-0 !tw-mx-auto !tw-text-normal tw-w-full"
                label="POŠLJI KODO"
                :type="'primary'"

                @click="onInitiateAuthClientViaPOBRAuthContact"
            ></ui-button>

          </div>
        </ui-formgroup>

        <!-- IDENTIFIKACIJA S SMS KODO - ENTER OTP -->
        <ui-formgroup
            v-if="currentStep === 61"
            :key="61"
            class="tw-absolute tw-w-full"
        >
          <div
              class="
                content tw-mx-auto tw-mt-skip-header
                mini:tw-w-11/12
                mob:tw-w-[343px]

                desktop:tw-mt-skip-header-d"
          >
            <p
                class="
                  potrditev-alternativnega-kontakta-text
                  tw-mt-mid tw-mb-xs tw-pt-mid
                  tw-text-center tw-text-normal tw-leading-22 tw-text-tzz-dark-gray

                  desktop:tw-pt-extra"
            >
              Na telefonsko številko:
            </p>

            <p
                class="
                  potrditev-alternativnega-kontakta-text
                  tw-mb-xs
                  tw-text-center tw-text-normal tw-leading-22 tw-font-bold tw-text-tzz-dark-gray"
            >
              {{ authContactPreAuth }}
            </p>
            <p
                class="
                  potrditev-alternativnega-kontakta-text
                  tw-mb-mid
                  tw-text-center tw-text-normal tw-leading-22 tw-text-tzz-dark-gray"
            >
              smo vam poslali validacijsko kodo za dostop.
            </p>

            <p
                class="
                  potrditev-alternativnega-kontakta-text
                  tw-mt-0 tw-mb-small
                  tw-text-center tw-text-normal tw-leading-22 tw-text-tzz-dark-gray"
            >
              Vpišite kodo:
            </p>

            <ui-code-input
                ref="alternative-sign-submission-phone-code-input"
                :length="5"
                @validated="allowAuthClientViaPOBRAuthContactOTPCheck = $event; authClientViaPOBRAuthContactOTPInput = undefined;"
                @valid="authClientViaPOBRAuthContactOTPInput = $event"

                class="tw-mb-40"
            >
            </ui-code-input>

            <ui-button
                class="
                  soglasje-sdd-eracun__pregled-izbira-kontakta-check
                  !tw-w-full !tw-m-0 !tw-mb-big
                  !tw-text-[14px]"
                label="PREVERI KODO"
                :type="'primary'"
                :disabled="!allowAuthClientViaPOBRAuthContactOTPCheck"
                @click="onEnter()"
            ></ui-button>

            <p
                class="
                  potrditev-alternativnega-kontakta-text
                  tw-mt-0 tw-mb-xs
                  tw-text-center tw-text-normal tw-leading-22 tw-text-tzz-dark-gray"
            >
              Niste prejeli sporočila?
            </p>

            <button
                class="
                  tw-block tw-mx-auto tw-mb-mid
                  tw-text-[15px] tw-font-bold tw-text-tzz-blue tw-outline-none"
                @click="onInitiateAuthClientViaPOBRAuthContact()"
            >
              Pošlji znova
            </button>

            <p
                class="
                  potrditev-alternativnega-kontakta-text
                  tw-mt-0 tw-mb-xs
                  tw-text-center tw-text-normal tw-leading-22 tw-text-tzz-dark-gray"
            >
              V primeru težave pri prejemu gesla nas pokličite na
              <button
                  @click="onTZZCall"

                  class="tw-font-bold tw-underline"
              >
                080 26 64.
              </button>
            </p>
          </div>
        </ui-formgroup>

      </ui-form>
    </div>

  </div>
</template>

<script>
import {mapGetters} from 'vuex';
import UIMiniLoader from "@/components/ui/UIMiniLoader";
import UIFormGroup from "@/components/ui/UIFormGroup";
import UIButton from "@/components/ui/UIButton";
import UIButtonWithIcon from "@/components/ui/UIButtonWithIcon";

import POBR_mixin from '../mixins/POBR.mixin';
import Validators_mixin from '../mixins/validators.mixin';
import CommonMixin from "@/mixins/common.mixin";
import POBRAuthMixin from "@/mixins/POBR-Auth.mixin";

import Header from "@/components/Header";
import UIForm from "@/components/ui/UIForm";
import UIInput from "@/components/ui/UIInput";
import UIDatepicker from "@/components/ui/UIDatepicker";
import StevilkaZdravstveneKarticeInfo from "@/components/ui/StevilkaZdravstveneKarticeInfo";
import UICodeInput from "@/components/ui/UICodeInput";

export default {
  name: "POBRAuth",
  extends: {
    mixins: [
      CommonMixin,
      Validators_mixin,
      POBR_mixin,
      POBRAuthMixin,
    ]
  },

  data() {
    return {
      authLoading: false,
      currentStep: 0,
      stepsHistory: [],

      // davcna
      vatNumberInput: undefined,
      davcnaValidate: undefined,

      // kzz
      kzzInput: undefined,
      kzzValidate: undefined,

      // datum rojstva
      birthDateInput: undefined,
      birthDateOpen: new Date(1996, 0, 1),

      // auth method 4
      allowVATbirthDateEnter: false,
      allowVATKZZEnter: false,

      // auth method 6
      allowAuthClientViaPOBRAuthContactOTPCheck: false,
      authClientViaPOBRAuthContactOTPInput: undefined,

      keydownEL: undefined
    }
  },

  computed: {
    ...mapGetters(['hideHeader'])
  },

  mounted() {
    this.davcnaValidate = [this.VALIDATORS.VAT];
    this.kzzValidate = [this.VALIDATORS.KZZ];

    this.keydownEL = this.onKeydown.bind(this);
    document.addEventListener('keydown', this.keydownEL);
  },

  destroyed() {
    document.removeEventListener('keydown', this.keydownEL);
  },

  methods: {
    onOpenITriglav() {
      window.open(
          `https://${process.env.VUE_APP_ITRIGLAV_ROOT_URL}/TriglavLogin?returnCookie=true&redirectTo=${window.location.href}`,
          "_self"
      );
    },
    onStepChange(toStep) {
      if (toStep === 'BACK') {

        if (this.currentStep === 3 || this.currentStep === 4) {
          this.stepsHistory = [0, 1];
        }

        this.currentStep = this.stepsHistory.pop();
      } else {
        this.stepsHistory.push(this.currentStep);
        this.currentStep = toStep;
      }

      if (this.currentStep < 2) {
        this.selectedAuthAlternativeId = undefined;
      }
    },
    selectAlternativeAuthMethod(amId) {
      this.selectedAuthAlternativeId = amId;

      if (amId !== 9) {
        this.onStepChange(amId);
      } else {
        this.onEnter();
      }
    },
    async onEnter() {
      if (this.authData && this.authData.iTriglav) {
        const moveQuery = {};

        if (this.queryObject.wv === 'true') {
          moveQuery.x = 'wv=true';
        }

        await this.$router.push({
          name: 'POBR',
          params: {
            id: this.authData.id
          },
          query: moveQuery
        });
      } else {
        switch (this.selectedAuthAlternativeId) {
          case 3: {
            await this.attemptAlternativeAuth(this.queryObject.id, this.queryObject.tid, this.queryObject.ep, this.queryObject.pid, this.vatNumberInput, this.kzzInput, undefined);
            break;
          }

          case 4: {
            await this.attemptAlternativeAuth(this.queryObject.id, this.queryObject.tid, this.queryObject.ep, this.queryObject.pid, this.vatNumberInput, undefined, this.birthDateInput);
            break;
          }

          case 6: {
            await this.attemptAlternativeAuth(this.queryObject.id, undefined, undefined, undefined, undefined, undefined, undefined, this.authClientViaPOBRAuthContactOTPInput);
            break;
          }

          case 9: {
            await this.attemptAlternativeAuth(undefined, this.queryObject.tid, this.queryObject.ep);
          }
        }
      }
    },
    async onInitiateAuthClientViaPOBRAuthContact() {
      await this.initiateAuthClientViaPOBRAuthContact();
      this.notifySuccess('Verifikacijska koda uspešno poslana prek SMS.');

      this.onStepChange(61);
    }
  },

  components: {
    'ui-mini-loader': UIMiniLoader,
    'ui-header': Header,
    'ui-formgroup': UIFormGroup,
    'ui-form': UIForm,
    'ui-button': UIButton,
    'ui-button-with-icon': UIButtonWithIcon,
    'ui-input': UIInput,
    'ui-datepicker': UIDatepicker,
    'stevilka-zdravstvene-kartice-info': StevilkaZdravstveneKarticeInfo,
    'ui-code-input': UICodeInput
  }

}
</script>

<style scoped lang="scss">

@media screen and (min-width: 280px) {
  #content {
    .pobr_auth {
      &__itriglav {
        height: 290px;

        background-image: url('./../assets/itriglav.png');

        &-shadow {
          background: linear-gradient(0deg, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2));
        }
      }

      &__itriglav-logged_in {
        height: 290px;
        background: linear-gradient(93.81deg, #1ea89c 0%, #006c68 100%);
      }
    }
  }
}

@media (orientation: landscape) {
  #content {
    .pobr_auth {
      &__itriglav {
        height: unset;
      }

      &__itriglav-logged_in {
        height: unset;
      }
    }
  }
}

</style>
